import React from 'react';
import CertificateManagementPage from '../../pages/admin/CertificateManagementPage';

function CertificateManagement() {
    return <CertificateManagementPage />;
}

export default CertificateManagement; 